import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";


import Bienvenido from './componentes/app/Bienvenido.jsx';
import { Logeo } from './componentes/logeo/Logeo'
import { FacturacionSinRegistro } from './componentes/app/FacturacionSinRegistro';
import { CambioContrasena } from './componentes/logeo/CambioContrasena';

function App() {
  return (

    <BrowserRouter>
      <Switch>
        <Route path="/Capufe" component={Logeo} exact />
        <Route path="/Capufe/bienvenido" component={Bienvenido} />
        <Route path="/Capufe/facturacionrapida" component={FacturacionSinRegistro} />
        <Route path="/Capufe/cambiocontrasena/:id?" component={CambioContrasena} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;

